import styles from './Logo.module.css';

/**
 * 다잇 워드마크.
 *
 * daeat_512x512.png(앱 아이콘)를 웹용으로 다시 뽑은 daeat_logo.png를 쓴다.
 * 원본은 상하 30% · 좌우 15%가 여백이고 배경이 투명이 아닌 불투명 흰색(#FEFEFE)이라,
 * 오프화이트 배경 위에서 흰 사각형으로 드러난다. 253KB이기도 하다.
 * 웹용은 글자만 잘라내고 흰 배경을 알파로 되돌린 227×128 · 9KB다.
 * 원본은 apple-touch-icon으로 계속 쓰인다.
 *
 * 크기는 height prop(px) 또는 className에서 --logo-h로 정한다.
 * 반응형으로 달라져야 하면 인라인 스타일이 미디어쿼리를 이기므로 후자를 써야 한다.
 *
 * @param {number} [height]  로고 높이(px). 생략하면 CSS가 정한다(기본 22px)
 */
export default function Logo({ height, className = '' }) {
  return (
    <img
      src="/daeat_logo.png"
      alt="다잇"
      width={227}
      height={128}
      className={`${styles.logo} ${className}`.trim()}
      style={height ? { '--logo-h': `${height}px` } : undefined}
    />
  );
}
